import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-carica-flusso',
	templateUrl: './carica-flusso.component.html',
	styleUrls: ['./carica-flusso.component.css']
})
export class CaricaFlussoComponent implements OnInit {
	@Input() loaded: string;
	@Input() saved: boolean;
	@Input() writePermission: boolean = false;
	@Output() innerEvents = new EventEmitter();

	selected: any;
	flowsSync: Subscription;
	flows: any[] = [];

	constructor(private dataService: DataService){}

	ngOnInit() {
		this.flowsSync = this.dataService.flows$.subscribe(
			flows => {
				this.getFlows(flows);
			});
		this.selected = this.loaded;
	}

	getFlows(flows:any) {
		this.flows = [];

		for (let flow of flows) {
			if (flow.obsoleto == '-1') {
				this.flows.push(flow);
			}
		}
	}

	hide(){
		let event:any = {
			hide : true
		}
		this.innerEvents.emit(event);
	}

	discard() {
		this.hide();
	}

	loadFlow() {
		let event:any = {
			hide : true,
			flowEvent : true,
			data : {
				type : 'loadFlow',
				content : this.selected
			}
		}
		this.innerEvents.emit(event);
	}

	checkActiveFlow() {
		for (let flow of this.flows) {
			if ( flow.attivo == '1' ) {
				this.selected = flow.id;
			}
		}
	}

	isDefaultFlow(flow: any) {
		return flow.comune_id == null;
	}

	ngOnDestroy() {
		this.flowsSync.unsubscribe();
	}

}
